/**
 * THE DESIGN SYSTEM'S UTILITY CLASS NAMES -- the SSOT for every bare class string a React leaf writes to reach a rule
 * the emitted base stylesheet owns.
 *
 * WHY A LEAF AND NOT A LITERAL AT EACH SITE. These names are a HANDSHAKE across two layers that never see each other's
 * source: `const/design-tokens-static-css.ts` emits the RULE and a component writes the CLASS, and a `className`
 * naming no rule is perfectly valid markup. The drift is therefore silent -- which is precisely how four
 * `components/` leaves came to write `class="sr-only"` against a rule only TAILWIND defined, so every consumer with no
 * Tailwind pipeline (the mission viewer imports the base sheet raw) rendered their hidden text as ordinary visible
 * text, and no gate anywhere could see it (operator's accessibility sweep of the mission viewer, 2026-09-14).
 *
 * `interactive-hover` AND THE ROW CLASSES ARE DELIBERATELY NOT HERE YET: this leaf carries the names this change
 * actually moved, and a speculative roster of every class in the sheet would be inventory. A name joins when its
 * second consumer lands.
 */

export const DESIGN_SYSTEM_UTILITY_CLASSES = {
	/** Read aloud, never drawn: the class on a heading or a label that owes an accessible name and no ink. */
	srOnly: 'sr-only',
} as const;
